import listComponent from '@/util/proto/listComponent'
import CompanyItem from './detail'
import CompanyItemView from './view'
import CompanyBranch from './branch'
import companyMapView from './map'
import companyBlock from './block'
import { createDict } from '@/util/dicts'
import { getStaticPath } from '@/util/request'
import global from '@/util/mixin/global'

import Info from './partial/info'
import UpdatePhoto from './partial/update-photo'
import { saveFile } from '@/util'

//import ExportBox from '@/views/common/partial/export-verify'

//公司信息变更状态：0、待完善（已新建）；1、已提交（待审核）；2、待修改；3、正常
const infoStatusIcon = [
  { value: 0, label: 'error' },
  { value: 1, label: '#1890ff' },
  { value: 2, label: 'warning' },
  { value: 3, label: 'success' },
]


// const infoStatusIcon = (d) => {

//   if(d.state == 1){

//   }
// }

export default {
  extends: listComponent,
  mixins:[global],
  data() {
    return {
      columns: [
        {
          type: 'selection',
          width: 45,
          align: 'center'
        },
        {
          title: '企业名称',
          key: 'companyName',
          minWidth: 400,
          maxwidth: 500,
          render:(h , {row}) => {
            return  <div style={{ display: 'flex', alignItems: 'center' }}>
              <sl-badge title={row.infoStatusText} style={{'marginRight':'12px'}} status={row.infoStatusIcon} />
              <div style={{'flex':'1 1 auto'}}>
                <div class="tb-list-item-cell">
                  <div class="tb-list-item-cell-l">
                    <span title={row.id}>{row.companyName}</span>
                  </div>
                  <div class="tb-list-item-cell-r">
                    <span style="margin-right:8px;">{row.brandName}</span><span>{row.stateText}</span>
                  </div>
                </div>
                <div class="tb-list-item-cell">
                  <div class="tb-list-item-cell-l light">
                    <sl-tag color={row.infoStatusIcon} style={{'fontSize':'10px','opacity':'0.75'}}>{row.infoStatusText}</sl-tag>
                    <span>{row.location}</span>
                  </div>
                  <div class="tb-list-item-cell-r">
                    <span>{row.legalName}</span>
                    {row.companyPhone ? <span style="margin-left:8px;"><Icon type="md-call" style="margin-right:5px;" />{row.companyPhone}</span> : null }
                  </div>
                </div>
              </div>
            </div>
          }
        },
        {
          title: '巡检状态',
          key: 'establishDatetime',
          width: 150,
          render:(h , {row}) => {
             return <div style={{'flex':'1 1 auto'}}>
              <div class="tb-list-item-cell">
                <div class="tb-list-item-cell-l" style="font-size:13px;">
                  巡检状态
                </div>
              </div>
              <div class="tb-list-item-cell">
                <div class="tb-list-item-cell-l light">
                  <span>{row.inspectionStateText}</span>
                </div>
              </div>
            </div>
          }
        },
        {
          title: '成立时间',
          key: 'establishDatetime',
          width: 200,
          render:(h , {row}) => {
             return <div style={{'flex':'1 1 auto'}}>
              <div class="tb-list-item-cell">
                <div class="tb-list-item-cell-l" style="font-size:13px;">
                  成立时间
                </div>
              </div>
              <div class="tb-list-item-cell">
                <div class="tb-list-item-cell-l light">
                  <span>{row.establishDatetimeText}</span>
                </div>
              </div>
            </div>
          }
        },
        {
          title: '操作',
          key: 'action',
          width: 285,
          fixed: "right",
          align: 'center',
          render: (h, {row}) => {

            let acts = [
              <a v-permission="company.info.query" on-click={()=>this.view(row)}>查看</a>,
              <a v-permission="company.info.children" on-click={()=>this.viewChildren(row)}>下级网点</a>,
            ]

            if( this.isAdmin ){
              if( row.infoStatus == 1 ){
                if(this.$a('company.info.approval')){
                  acts.push(<a on-click={()=>this.viewCommit(row , true)}>审核</a>)
                }
              }else{
                if(this.$a('company.info.update')){
                  acts.push(<a on-click={()=>this.edit(row)}>编辑</a>)
                }
              }

              if(this.$a('company.info.enable')){
                acts.push(<a on-click={()=>this.toggle(row)}>{row.state == 1 ? '启用' : '禁用'}</a>)
              }  
            }else if( this.isCompany ){
              if( row.infoStatus == 1 ){
                if(this.$a('company.info.changes')) 
                  acts.push(<a on-click={()=>this.viewCommit(row)}>查看审核</a>)
              }else{
                if(this.$a('company.info.update')) 
                  acts.push(<a v-permission="company.info.update" on-click={()=>this.edit(row)}>编辑</a>)
              }
            }else if(this.isSupervisor){
              if(this.$a('company.info.update')){
                acts.push(<a on-click={()=>this.edit(row)}>编辑</a>)
              }
              if(this.$a('company.info.photos')) 
                acts.push(<a on-click={()=>this.updatePhoto(row)}>企业照片</a>)
            }

            if( this.isAS ){
              acts.push(<a on-click={()=>this.viewVideoLive(row)}>查看视频</a>)
            }
            return this.$utils.link(acts, <Divider type="vertical" />)
          }
        }
      ],
      data: [],

      params: {
        companyName:null,
        infoStatus:null,
        districtCode:null,
        companyType:null,
        brandId:null,
        inspectionState:null,
        state:null
      },

      loading: false,
    }
  },
  // computed:{
  //   brands(){
  //     return this.$request.brands(0).then(resp => {
  //       return Promise.resolve((resp.data || []).map(i => ({ value: i.id, label: i.brandShortName })))
  //     })
  //   }
  // },
  watch: {
    $route(to, from) {
      this.search()
    }
  },
  computed:{
    importUrl() {
      return this.$request.companyImportUrl()
    }
  },
  created() {
    this.def = { ...this.params }
    this.search()
  },

  methods: {
    search() {
      let params = { search: { ...this.params }, pageSize: this.page.pageSize, pageNum: this.page.pageNum }
      this.loading = true
      this.$request.companies(params).then(resp => {
        this.loading = false
        if (!resp.code) {
          this.data = this.$utils.conv(resp.data.list || [], { 'establishDatetime': 'date', 'companyType': '$companyType', 'state': '$enable', 'companyNature': '$companyNature', 'location': 'area' , 'infoStatus:infoStatusIcon':infoStatusIcon , 'infoStatus':'companyInfoStatus','inspectionState':'companyInspectionState' })
          this.page.total = resp.data.total || 0
        }
      })
    },

    edit( row ) {
      this.modalVisible = true
      this.$refs['item'].init(row.id)
    },

    create() {
      this.modalVisible = true
      this.$refs['item'].init(0)
    },

    //查看
    view(row) {
      this.$refs['itemView'].init(row.id)
    },

    viewCommit(row , reviewable = false){
      this.$dialog({
        title: '企业变更详情',
        // width: 700,
        fullscreen:true,
        paddingless: true,
        render: (h) => {
          return <Info reviewable={reviewable} companyId={row.id} />
        },
        onOk:({data})=>{
          console.log(data)
          if(data) this.search()
        }
      })
    },

    viewVideoLive(row){
      let device  = (row.companyDevices || []).find(i => i.deviceType == 0)
      if( device ){
        this.loading = true
        this.$request.companyDeviceLive(device.id).then(resp => {
          this.loading = false

          if( resp.code ){
            this.$Message.error(resp.msg)
          }else{
            this.$dialog({
              width: '80vw',
              transitionNames: ['none', 'none'],
              paddingless: true,
              render: (h) => {
                let options = {
                  autoplay: true,
                  video: {
                    url: resp.data.liveAddress,
                    type: 'auto',
                  },
                }
                return <sl-video options={options} style="height:80vh;width:80vw;text-align:center;background:#000;"></sl-video>
              }
            })
          }
        })
      }else{
        this.$Message.error('没有在线的监控设备')
      }
      
      // this.$dialog({
      //   width: '80vw',
      //   transitionNames: ['none', 'none'],
      //   paddingless: true,
      //   render: (h) => {
      //     let src = `https://doc.zjtianyoukeji.com/video/${type}.mp4`
      //     return <div style="height:80vh;width:80vw;text-align:center;background:#000;"><video style="width:100%;height:100%;object-fit: contain;" controls="controls" autoplay="autoplay" src={src} /></div>
      //   }
      // })
    },
    remove( row ) {
      this.$ui.confirm(this.$request.companyDelete, `确定删除 ${row.companyName} ？`)(row.id).then(resp => {
        if (!resp.code) {
          this.$Message.success('操作成功')
          this.search()
        }
      })
    },

    toggle( row ) {
      this.$request.companyToggle(row.id).then(resp => {
        if (resp.code) {
          this.$Message.error(resp.msg)
        } else {
          this.$Message.success('操作成功')
          this.search()
        }
      })
    },

    updatePhoto(row){
      this.$dialog({
        title: '变更企业照片',
        width: 700,
        paddingless: true,
        render: (h) => {
          return <UpdatePhoto value={row.netPhotos} companyId={row.id} />
        }
      })
    },

    reset() {
      this.params = {}
      this.search()
    },

    mapview() {
      // this.$refs['itemMapView'].init()
      this.$router.setRouteByCode('company.map.new' , {} , true)
    },
    viewChildren( row ) {
      this.$refs['branch'].init(row.id)
    },

    handleSearchChange(v) {
      let params = { ...v }
      this.params = params
      this.search()
    },
    handleExportWithSms(ids){
      let search = { ...this.params }
      if( ids && ids.length > 0 ){
        search = { ids }
      }

      let params = { search }
      this.$sms({
        title: '导出',params,api:'companyExport',disabled:true
      })
    },
    handleExport(ids){
      let search = { ...this.params }
      if( ids && ids.length > 0 ){
        search = { ids }
      }

      let params = { search }
      return this.$request.companyExport(params).then(resp => {
        saveFile(resp)
        return Promise.resolve()
      })
    },
    handleImportComplete(resp) {
      if (resp.code) {
        this.$Modal.warning({ title: '企业导入', content: resp.msg.replace(/[\r\n;]/g, '<br />') })
      } else {
        this.$Notice.success({ title: '导入成功', duration: 20, desc: '您可在 基础设置->导入管理 中查看处理结果！' })
      }
      this.search()
    },
  },
  render(){
    const { searchBoxOptions, reset, handleSearchChange } = this
    const tableScopedSlots = this.$a('company.info.export') ? {
      batch:({selection , enable}) => {
        return <Button type="primary" icon="md-download" on-click={()=>this.handleExport(selection)}>导出</Button>
      }
    } : {}
    return (
      <sl-page>
        <div class="page-filter">
          <sl-search on-search={this.search} on-reset={this.reset} showCount={4} >
            <sl-search-item label="">
              <i-input v-model={this.params.companyName} placeholder="企业名称" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-area v-model={this.params.districtCode} data-type="code" placeholder="所在区域" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select dict='brand' v-model={this.params.brandId} placeholder="所属品牌" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select dict='companyInspectionState' v-model={this.params.inspectionState} placeholder="巡检信息" />
            </sl-search-item>
            <sl-search-item label="">
              <sl-select v-model={this.params.infoStatus} dict="companyInfoStatus" placeholder="信息完善状态" />
            </sl-search-item>
            <sl-search-item>
              <sl-select v-model={this.params.companyType} dict="companyType" placeholder="企业类型" />
            </sl-search-item>
            <sl-search-item>
              <sl-select v-model={this.params.state} dict="enable" placeholder="状态" />
            </sl-search-item>
            <template slot="action">
              {/*<Button v-permission="company.info.map" type="primary" icon="md-map" on-click={this.mapview}>地图模式</Button>*/}
              <sl-upload-file style="margin-left:24px;" action={this.importUrl} enable-reply={false} on-complete={this.handleImportComplete} reply-type="modal" error-title="导入失败">
                <template slot="tip">
                  <sl-a href="@template/company.xlsx" name="企业导入模板.xlsx">模板下载</sl-a>
                </template>
                <Button icon="ios-cloud-upload-outline">导入</Button>
              </sl-upload-file>,
              <Button v-permission="company.info.insert" style="margin-left:8px;" type="primary" icon="md-add" on-click={this.create}>新增</Button>
            </template>
          </sl-search>
        </div>

        <div class="pg-bd">
          <sl-table showHeader={false} loading={this.loading} page={this.page} columns={this.columns} data={this.data} on-change={this.$tableChange} selectionKey="id" scopedSlots={tableScopedSlots}>
          </sl-table>
        </div>
        <CompanyItem ref="item" on-update={this.search} />
        <CompanyItemView ref="itemView" />
        <CompanyBranch ref="branch" on-update={this.search} />
      </sl-page>
    )
  }
}